import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";
import { Button } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    padding: '7px 30px',
    fontSize: 17,
  },
  linkGroup: {
    textDecoration: 'none',
    marginTop: 15,
  },
})

export default function ButtonOK(){
  const classes = useStyles();

  return(
    <Link to="/" className={classes.linkGroup}>
    <Button variant="contained" color="primary" className={classes.button}>
      Ok!
    </Button>
  </Link>
  );
}